import { BaseRepository } from './BaseRepository';
import { NexxusDatabase, getDatabase } from './NexxusDatabase';
import type { User } from '@shared/types/User';
import type { IUserRepository } from '@infra/auth/AuthService';
import { uuid } from '@shared/utils/uuid';

export class UserRepository extends BaseRepository<User> implements IUserRepository {
  constructor(db?: NexxusDatabase) {
    super((db ?? getDatabase()).users);
  }
  async findByEmail(email: string, tenantId?: string): Promise<User | undefined> {
    const normalized = email.toLowerCase().trim();
    const matches = await this.table.where('email').equals(normalized).toArray();
    if (tenantId) {
      return matches.find((user) => user.tenant_id === tenantId);
    }
    if (matches.length !== 1) return undefined;
    return matches[0];
  }
  async findById(id: string): Promise<User | null> {
    return super.findById(id);
  }
  async create(user: Omit<User, 'id'>): Promise<User> {
    const created: User = { ...user, id: uuid('user') };
    await this.table.put(created);
    return created;
  }
}
